export enum SlipTypes {
  COMBINATION = 'combination',
  SYSTEM = 'system',
}

export enum SlipCreationModalTypes {
  CONFIRM_CREATING,
  SLIP_CREATED,
  LIVE_QUOTE_REVIEW,
  QUOTE_SUSPENDED,
}

export const enum SlipStatus {
  OPEN = 'pending',
  CLOSED = 'closed',
  WINNING = 'winning',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  RETURNED = 'returned',
}

export const enum SlipInputValueTypes {
  STAKE_PER_BET,
  TOTAL_STAKE,
  MAX_GAIN,
}

export const enum ToastMessagesIDs {
  LOGIN_ERROR,
  CHANGE_PASSWORD_ERROR,
  SLIP_INPUT_VALUE_ERROR,
  CASINO_GAMES_ACCESS_ERROR,
  LIVE_SLIP_SELECTION_REMOVED,
  SLIP_MAX_MATCHES,
}

export const enum SportIDs {
  SOCCER = 1,
  TENNIS = 13,
  ICE_HOCKEY = 17,
  BASKETBALL = 18,
  HANDBALL = 78,
  VOLLEYBALL = 91,
}

export const enum LiveBettingFilters {
  LIVE_EVENTS = 'live_events_label',
  UPCOMMING_EVENTS = 'upcomming_events_label',
  MY_LIVE_FAVORITES = 'my_live_favorites_label',
}

export const enum CssLabels {
  HigherValue = 'higher-value',
  LowerValue = 'lower-value',
  SameValue = '',
}
